<form #topOfViaSurveyBlock *ngIf="block && form" [formGroup]="form">
  <div *ngIf="isLoading(); else viaSurveyContainer" class="flex h-full w-full items-center justify-center">
    <pl-loader />
  </div>
  <ng-template #viaSurveyContainer>
    <div class="flex flex-col gap-6">
      <ng-container *ngIf="section() === ViaSurveySection.questions" class="flex flex-col gap-6">
        <div class="pl-inner-html" [innerHTML]="block.data.intro_survey.value"></div>
        <p class="text-center text-lg">{{ pageNumber() }} / {{ totalPages() }}</p>
        <ng-container [formArrayName]="FormControlName.viaSurveyQuestions">
          <ng-container *ngFor="let block of formArrayBlocks.controls; let index = index">
            <pl-block-radiobox #radioBox [formControlName]="index + ''" [isDisabled]="isDisabled" />
          </ng-container>
        </ng-container>
      </ng-container>

      <ng-container *ngIf="section() === ViaSurveySection.results">
        <div class="pl-inner-html" [innerHTML]="block.data.intro_results_2.value"></div>

        <ng-container *ngIf="!versionBeforeProgram">
          <div class="pl-inner-html" [innerHTML]="block.data.during_program_title_result.value"></div>
          <pl-checkbox
            [label]="block.data.config.title_strength_list || ''"
            [formControlName]="FormControlName.strengthList"
            [isFormSubmitted]="courseContentService.isMainFormSubmitted()"
            [isDisabled]="isDisabled"
            [minSelected]="block.data.config.strength_list_min_selected"
            [maxSelected]="block.data.config.strength_list_max_selected"
            [minItemsDisplayed]="5"
          />
        </ng-container>

        <div
          class="pl-inner-html"
          *ngIf="block.data.before_program_title_result.value"
          [innerHTML]="block.data.before_program_title_result.value"
        ></div>

        <div *ngIf="!!downloadPdfButtonConfig()" class="flex w-full justify-center">
          <pl-block-button [ngModel]="downloadPdfButtonConfig()" [ngModelOptions]="{ standalone: true }" />
        </div>

        <div
          class="pl-inner-html"
          *ngIf="versionBeforeProgram"
          [innerHTML]="block.data.before_program_after_button.value"
        ></div>
      </ng-container>
    </div>
  </ng-template>
</form>
